module.exports = __webpack_public_path__ + "img/sh_17.358a9dda.jpg";